var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_SHIPMENT_LABEL_FILE_REQUEST, fetchShipmentLabelFailure, fetchShipmentLabelSuccess, } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onDownloadLabel = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(`/cnvt/shipment/label/order/${action.payload.orderId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* downloadLabelWorker(action) {
    try {
        const data = yield call(onDownloadLabel, action);
        yield put(fetchShipmentLabelSuccess(data));
    }
    catch (error) {
        // Serialize the error here
        const serializedError = {
            message: error.message,
            name: error.name,
            code: error.code,
            response: error.response
                ? {
                    status: error.response.status,
                    data: error.response.data,
                }
                : null,
        };
        yield put(fetchShipmentLabelFailure(serializedError));
    }
}
export function* watchDownloadLabelData() {
    yield takeLatest(FETCH_SHIPMENT_LABEL_FILE_REQUEST, downloadLabelWorker);
}
